import React from 'react'

interface FileDetailsHeaderProps {
  sourceName: string
  filename: string
  onBack: () => void
}

const FileDetailsHeader: React.FC<FileDetailsHeaderProps> = ({ sourceName, filename, onBack }) => {
  return (
    <div className="file-details-header">
      <button className="back-btn" onClick={onBack}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 5L7 12L14 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="8" y1="12" x2="20" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
        <span className="breadcrumb-text">{sourceName} / {filename}</span>
      </button>
    </div>
  )
}

export default FileDetailsHeader